// extracted by mini-css-extract-plugin
var _1 = "reset_resetBaseFont__c3503";
export { _1 as "resetBaseFont" }
